import { buildComponent } from '#components'

import './footer-newsletter.css'

const FooterNewsletter = buildComponent({
  name: 'footer-newsletter',
  onConnected: (component) => {
    const successEl = component.querySelector('#mce-success-response')

    if (!successEl) return

    const successObserverConfig = {
      config: { attributes: true },
      callback: () => {
        const message = successEl.getAttribute('data-text')

        if (!message) return

        successEl.innerHTML = message
        component.classList.add('success')
      }
    }

    const successObserver = new MutationObserver(successObserverConfig.callback)

    successObserver.observe(successEl, successObserverConfig.config)
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'footer-newsletter': typeof FooterNewsletter
  }
}
